import React, { useEffect, useState } from "react";
import Select from "react-select";

// modal
import Modal from "../Modal";

// style
import RightSidebarStyle from "./style";

// img
import Close from "../../Assets/Close.svg";

// -- redux
import { connect } from "react-redux";
import { EditProduct, DeleteProduct, AddProduct } from "../../Redux/Actions/ProductAction";

function RightSidebar(props) {
  const [response, setResponse] = useState(false);
  const [Title, setTitle] = useState("");
  const [UserType, setUserType] = useState("");
  const [UserTypeID, setUserTypeID] = useState("");
  const [TitleError, setTitleError] = useState("");
  const [Type, setType] = useState("");
  const [TypeID, setTypeID] = useState("");
  const [Information, setInformation] = useState("");
  const [AndroidUrl, setAndroidUrl] = useState("");
  const [IOSUrl, setIOSUrl] = useState("");
  const [AndroidInformationError, setAndroidInformationError] = useState("");
  const [IosInformationError, setIosInformationError] = useState("");
  const [InformationID, setInformationID] = useState("");
  const [InformationError, setInformationError] = useState("");
  const [Time, setTime] = useState("");
  const [Apr, setApr] = useState("");
  const [Apy, setApy] = useState("");
  const [Description, setDescription] = useState("");
  const [DescriptionError, setDescriptionError] = useState("");
  const [OpenModal, setModal] = useState(false);
  const [AprError, setAprError] = useState("");
  const [ApyError, setApyError] = useState("");
  const [EstTimeError, setEstTimeError] = useState("");

  useEffect(() => {
    document.getElementById("SidebarForm").scrollTo(0, 0);
    props.data && setTitle(props.data.boxTitle);
  }, [props]);

  function toArray(obj) {
    if (obj == null) {
      return [];
    } else if (Array.isArray(obj)) {
      return obj;
    } else {
      return [obj];
    }
  }

  function iif(condition, trueObj, falseObj) {
    return condition ? toArray(trueObj) : toArray(falseObj);
  }

  const TypeOptions = [
    { value: "Tab", label: "Tab", id: "1" },
    { value: "App", label: "App", id: "2" },
    { value: "Service", label: "Service", id: "3" },
    { value: "WebView", label: "WebView", id: "4" },
  ];

  const UserTypeOptions = [{ value: "Personal Banking", label: "Personal Banking", id: "2" }, { value: "Business", label: "Business", id: "3" }, ...iif(sessionStorage.getItem("selectedBank") === "1", { value: "V1be User", label: "V1be User", id: "5" })];

  const KeyTabOptions = [
    { value: "Home", label: "Home", id: "1" },
    { value: "Products", label: "Products", id: "2" },
    { value: "Services", label: "Services", id: "3" },
    { value: "Social", label: "Social", id: "4" },
    { value: "Help", label: "Help", id: "5" },
  ];

  const KeyInformationOptions = [{ value: "Primis Banking", label: "Primis Banking", id: "21" }];

  const ServiceInformationOptions = [{ value: "Change Name", label: "Change Name", id: "11" }];

  useEffect(() => {
    if (props.data) {
      setTitle(props.data.title);
      setUserTypeID(props.data.user_type && props.data.user_type.toString());
      setTime(props.data.est_minutes);
      setApr(props.data.apr);
      setApy(props.data.apy);
      setDescription(props.data.description);
      setTypeID(props.data.type && props.data.type.toString());
      setInformation(props.data.information && props.data.information);
      setInformationID(props.data.information && props.data.information.toString());
      props.data.app_android_url === null ? setAndroidUrl("") : setAndroidUrl(props.data.app_android_url);
      props.data.app_ios_url === null ? setIOSUrl("") : setIOSUrl(props.data.app_ios_url);
    }
  }, [props]);

  useEffect(() => {
    setTimeout(function () {
      setResponse(true);
    }, 1000);
  }, []);

  const colourStyles = {
    control: (styles, state) => ({
      ...styles,
      backgroundColor: "#3C3C3C",
      border: state.isFocused ? "1px solid #A0A0A0" : "1px solid #3C3C3C",
      transition: "all 0.25s linear 0s",
      "&:hover": {
        border: "1px solid #A0A0A0",
      },
      padding: "4px 6px",
      boxShadow: state.isFocused ? null : null,
    }),
    singleValue: (baseStyles, state) => ({
      ...baseStyles,
      color: state.isFocused ? "#ffffff" : "#ffffff",
      backgroundColor: "#3C3C3C",
    }),
  };

  const CloseSidebar = (e) => {
    e.preventDefault();
    document.getElementById("SidebarForm").scrollTo(0, 0);
    setTitle("");
    setUserType("");
    setUserTypeID("");
    setType("");
    setTypeID("");
    setTime("");
    setApr("");
    setApy("");
    setDescription("");
    setInformation("");
    setAprError("");
    setApyError("");
    setTitleError("");
    setDescriptionError("");
    setAndroidUrl("");
    setIOSUrl("");
    setIosInformationError("");
    setAndroidInformationError("");
    props.close();
  };

  const handleModal = (e, type) => {
    e.preventDefault();
    if (type === "update" || type === "add") {
      if (Apr < 0 || Apr > 100) {
        setAprError("Invalid Apr");
      } else {
        setAprError("");
      }
      if (Apy < 0 || Apy > 100) {
        setApyError("Invalid Apr");
      } else {
        setApyError("");
      }
      if (Title.length < 5) {
        setTitleError("Title must be atleast 5 characters");
      } else {
        setTitleError("");
      }
      if (Description.length < 10) {
        setDescriptionError("Description must be atleast 10 characters");
      } else {
        setDescriptionError("");
      }
      if (TitleError.length === 0 && DescriptionError.length === 0 && AprError.length === 0 && ApyError.length === 0 && !(Description.length < 10)) {
        let expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
        let regex = new RegExp(expression);
        let expressionHttps = /^https:\/\//;
        let regexHttps = new RegExp(expressionHttps);
        if (TypeID === "4") {
          if (Information.match(regex)) {
            setInformationError("");
            setModal(type);
          } else {
            setInformationError("Invalid URL");
          }
        } else if (TypeID === "2") {
          if (AndroidUrl.match(regex) && AndroidUrl.match(regexHttps) && IOSUrl.match(regex) && IOSUrl.match(regexHttps)) {
            setAndroidInformationError("");
            setIosInformationError("");
            setModal(type);
          } else {
            if (AndroidUrl.match(regex) && AndroidUrl.match(regexHttps)) {
              setAndroidInformationError("");
            }
            if (IOSUrl.match(regex) && IOSUrl.match(regexHttps)) {
              setIosInformationError("");
            }
            if (AndroidUrl.match(regex) === null || AndroidUrl.match(regexHttps) === null) {
              setAndroidInformationError("Invalid URL");
            }
            if (IOSUrl.match(regex) === null || IOSUrl.match(regexHttps) === null) {
              setIosInformationError("Invalid URL");
            }
          }
        } else {
          setInformationError("");
          setIosInformationError("");
          setAndroidInformationError("");
          setModal(type);
        }
      }
    } else {
      setInformationError("");
      setIosInformationError("");
      setAndroidInformationError("");
      setModal(type);
    }
  };

  const CloseModal = (e, type) => {
    e.preventDefault();
    document.getElementById("SidebarForm").scrollTo(0, 0);
    if (type === "add_yes") {
      if (TypeID !== "4") {
        if (TypeID === "2") {
          const data = {
            title: Title,
            description: Description,
            apr: Apr,
            apy: Apy,
            user_type: UserTypeID,
            est_minutes: Time,
            type: TypeID,
            information: "",
            app_android_url: AndroidUrl,
            app_ios_url: IOSUrl,
          };
          props.AddProduct(data);
        } else {
          const data = {
            title: Title,
            description: Description,
            apr: Apr,
            apy: Apy,
            user_type: UserTypeID,
            est_minutes: Time,
            type: TypeID,
            information: InformationID,
          };
          props.AddProduct(data);
        }
      } else if (TypeID === "2") {
        const data = {
          title: Title,
          description: Description,
          apr: Apr,
          apy: Apy,
          user_type: UserTypeID,
          est_minutes: Time,
          type: TypeID,
          information: "",
          app_android_url: AndroidUrl,
          app_ios_url: IOSUrl,
        };
        props.AddProduct(data);
      } else {
        const data = {
          title: Title,
          description: Description,
          apr: Apr,
          apy: Apy,
          user_type: UserTypeID,
          est_minutes: Time,
          type: TypeID,
          information: Information,
        };
        props.AddProduct(data);
      }
    } else if (type === "add_no") {
      setModal(false);
    } else if (type === "update_yes") {
      if (TypeID !== "4") {
        if (TypeID === "2") {
          const data = {
            id: props.data.id,
            title: Title,
            description: Description,
            apr: Apr,
            apy: Apy,
            user_type: UserTypeID,
            est_minutes: Time,
            type: TypeID,
            information: "",
            app_android_url: AndroidUrl,
            app_ios_url: IOSUrl,
          };
          props.EditProduct(data);
        } else {
          const data = {
            id: props.data.id,
            title: Title,
            description: Description,
            apr: Apr,
            apy: Apy,
            user_type: UserTypeID,
            est_minutes: Time,
            type: TypeID,
            information: InformationID,
          };
          props.EditProduct(data);
        }
      } else if (TypeID === "2") {
        const data = {
          id: props.data.id,
          title: Title,
          description: Description,
          apr: Apr,
          apy: Apy,
          user_type: UserTypeID,
          est_minutes: Time,
          type: TypeID,
          information: "",
          app_android_url: AndroidUrl,
          app_ios_url: IOSUrl,
        };
        props.EditProduct(data);
      } else {
        const data = {
          id: props.data.id,
          title: Title,
          description: Description,
          apr: Apr,
          apy: Apy,
          user_type: UserTypeID,
          est_minutes: Time,
          type: TypeID,
          information: Information,
        };
        props.EditProduct(data);
      }
    } else if (type === "update_no") {
      setModal(false);
    } else if (type === "delete_yes") {
      props.DeleteProduct(props.data.id);
    } else if (type === "delete_no") {
      setModal(false);
    }
    if (type === "add_yes" || type === "update_yes" || type === "delete_yes") {
      setModal(false);
      setTitle("");
      setUserType("");
      setUserTypeID("");
      setType("");
      setTypeID("");
      setTime("");
      setApr("");
      setApy("");
      setAprError("");
      setApyError("");
      setTitleError("");
      setDescriptionError("");
      setDescription("");
      setAndroidUrl("");
      setIOSUrl("");
      setIosInformationError("");
      setAndroidInformationError("");
      props.close();
    }
  };

  const handleChange = (selected, type) => {
    if (type === "type") {
      setType(selected);
      setTypeID(selected.id);
      setInformation("");
      setInformationID("");
      setAndroidUrl("");
      setIOSUrl("");
      setIosInformationError("");
      setAndroidInformationError("");
    } else if (type === "information") {
      setInformation(selected);
      setInformationID(selected.id);
    } else {
      setUserType(selected);
      setUserTypeID(selected.id);
    }
  };

  const selectUserType = (selected) => {
    handleChange(selected);
    let userValues = "";
    const a = selected.selected.map((item) => {
      userValues += `${item.id},`;
    });
    // setUserType(selected.selected);
    setUserTypeID(userValues.substring(0, userValues.length - 1));
  };

  const handleTitle = (e) => {
    if (e.target.value.length < 51) {
      setTitle(e.target.value);
      setTitleError("");
    } else {
      setTitleError("Title must not be more than 50 characters");
    }
  };

  const handleDescription = (e) => {
    if (e.target.value.length < 501) {
      setDescription(e.target.value);
      setDescriptionError("");
    } else {
      setDescriptionError("Description must not be more than 500 characters");
    }
  };

  const handleApr = (e) => {
    if (e.target.value >= 0 && e.target.value <= 100) {
      setApr(e.target.value);
      setAprError("");
    } else {
      setAprError("Apr must be beteen 0-100");
      setTimeout(() => {
        setAprError("");
      }, 3000);
    }
  };

  const handleEstTime = (e) => {
    if (e.target.value >= 0 && e.target.value <= 999) {
      setTime(e.target.value);
      setEstTimeError("");
    } else {
      setEstTimeError("Can't be more than 999");
      setTimeout(() => {
        setEstTimeError("");
      }, 3000);
    }
  };

  const handleApy = (e) => {
    if (e.target.value >= 0 && e.target.value <= 100) {
      setApy(e.target.value);
      setApyError("");
    } else {
      setApyError("Apy must be beteen 0-100");
      setTimeout(() => {
        setApyError("");
      }, 3000);
    }
  };

  useEffect(() => {
    props.edit_data && response && props.response({ type: props.edit_data.status, message: props.edit_data.message });
  }, [props.edit_data]);

  useEffect(() => {
    props.delete_data && response && props.response({ type: props.delete_data.status, message: props.delete_data.message });
  }, [props.delete_data]);

  useEffect(() => {
    props.add_data && response && props.response({ type: props.add_data.status, message: props.add_data.message });
  }, [props.add_data]);

  const findType = (selected) => {
    for (let i = 0; i < TypeOptions.length; i++) {
      if (parseInt(TypeOptions[i].id) === parseInt(selected)) {
        return TypeOptions[i];
      }
    }
  };

  return (
    <>
      {props && props.sidebar && <div onClick={(e) => CloseSidebar(e)} className="dark-overlay" />}
      <div className={props && props.sidebar ? "dark-background right-sidebar-wrap" : "dark-background right-sidebar-wrap right-sidebar-wrap-close"}>
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="text-uppercase text-white">{props.Type} PRODUCTS</h5>
          <img onClick={(e) => CloseSidebar(e)} src={Close} alt="Close" className="cursor-pointer" />
        </div>
        <form className="sidebar-form-wrap" id="SidebarForm">
          <div className="mt-4">
            <label className="text-grey-6 f-16 d-block mb-1">
              Title <span className="text-danger">*</span>
            </label>
            <input value={Title} onChange={(e) => handleTitle(e)} type="text" placeholder="Enter Title" className="w-100 input-style" />
            {TitleError && <p className="f-12 text-danger">{TitleError}</p>}
          </div>
          <div className="mt-4">
            <div className="mr-2">
              <label className="text-grey-6 f-16 d-block mb-1">
                User Type <span className="text-danger">*</span>
              </label>
              <Select
                value={
                  UserTypeOptions.filter(function (option) {
                    return UserTypeID.indexOf(option.id) !== -1 ? option.id : UserTypeID == 1 ? option : "";
                  }) || ""
                }
                onChange={(selected) => selectUserType({ selected })}
                options={UserTypeOptions}
                styles={colourStyles}
                isMulti={true}
                placeholder="Choose Type"
              />
            </div>
          </div>
          <div className="d-flex mt-4">
            <div className="w-50">
              <label className="text-grey-6 f-16 d-block mb-1">
                Type <span className="text-danger">*</span>
              </label>
              <Select
                value={
                  TypeOptions.filter(function (option) {
                    return option.id === TypeID;
                  }) || ""
                }
                onChange={(e) => handleChange(e, "type")}
                options={TypeOptions}
                styles={colourStyles}
                placeholder="Choose Type"
              />
            </div>
            <div className="w-50 ml-2">
              <label className="text-grey-6 f-16 d-block mb-1">
                Est. Time to Open <span className="text-danger">*</span>
              </label>
              <input value={Time} onChange={(e) => handleEstTime(e)} type="number" placeholder="Enter Time" className="w-100 input-style" onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()} />
              {EstTimeError && <p className="f-12 text-danger">{EstTimeError}</p>}
            </div>
          </div>
          <div className="d-flex mt-4">
            <div className="w-50 mr-2">
              <label className="text-grey-6 f-16 d-block mb-1">
                APR <span className="text-danger">*</span>
              </label>
              <input value={Apr} onChange={(e) => handleApr(e)} type="text" placeholder="Enter APR" className="w-75 input-style" onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()} />
              <span className="ml-3 w-25 text-white f-20">%</span>
              {AprError && <p className="f-12 text-danger">{AprError}</p>}
            </div>
            <div className="w-50 ml-2">
              <label className="text-grey-6 f-16 d-block mb-1">
                APY <span className="text-danger">*</span>
              </label>
              <input value={Apy} onChange={(e) => handleApy(e)} type="text" placeholder="Enter APY" className="w-75 input-style" onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()} />
              <span className="ml-3 w-25 text-white f-20">%</span>
              {ApyError && <p className="f-12 text-danger">{ApyError}</p>}
            </div>
          </div>
          <div className="mt-4">
            <label className="text-grey-6 f-16 d-block mb-1">
              Description <span className="text-danger">*</span>
            </label>
            <textarea value={Description} onChange={(e) => handleDescription(e)} placeholder="Enter Description" className="w-100 text-input-style" />
            {DescriptionError && <p className="f-12 text-danger">{DescriptionError}</p>}
            <span className="text-white f-12">Max limit 500 characters</span>
          </div>

          {TypeID === "1" && (
            <div className="mt-4">
              <label className="text-grey-6 f-16 d-block mb-1">
                Key<span className="text-danger">*</span>
              </label>
              <Select
                value={
                  KeyTabOptions.filter(function (option) {
                    return option.id === InformationID;
                  }) || ""
                }
                onChange={(e) => handleChange(e, "information")}
                options={KeyTabOptions}
                styles={colourStyles}
                placeholder="Choose Type"
              />
            </div>
          )}
          {
            TypeID === "2" && (
              <>
                <div className="mt-4">
                  <label className="text-grey-6 f-16 d-block mb-1">
                    IOS url<span className="text-danger">*</span>
                  </label>
                  <input value={IOSUrl} onChange={(e) => setIOSUrl(e.target.value)} type="text" placeholder="Enter url" className="w-100 input-style" id="Key" />
                  {IosInformationError && <p className="f-12 text-danger">{IosInformationError}</p>}
                </div>
                <div className="mt-4">
                  <label className="text-grey-6 f-16 d-block mb-1">
                    Android url<span className="text-danger">*</span>
                  </label>
                  <input value={AndroidUrl} onChange={(e) => setAndroidUrl(e.target.value)} type="text" placeholder="Enter url" className="w-100 mt-2 input-style" id="Key" />
                  {AndroidInformationError && <p className="f-12 text-danger">{AndroidInformationError}</p>}
                </div>
              </>
            )
            // <div className='mt-4'>
            //     <label className='text-grey-6 f-16 d-block mb-1'>Key<span className='text-danger'>*</span></label>
            //     <Select
            //         value={KeyInformationOptions.filter(function(option) {
            //             return option.id === InformationID;
            //         }) || ''}
            //         onChange={(e) => handleChange(e, 'information')}
            //         options={KeyInformationOptions}
            //         styles={colourStyles}
            //         placeholder= 'Choose Type'
            //     />
            // </div>
          }
          {TypeID === "3" && (
            <div className="mt-4">
              <label className="text-grey-6 f-16 d-block mb-1">
                Key<span className="text-danger">*</span>
              </label>
              <Select
                value={
                  ServiceInformationOptions.filter(function (option) {
                    return option.id === InformationID;
                  }) || ""
                }
                onChange={(e) => handleChange(e, "information")}
                options={ServiceInformationOptions}
                styles={colourStyles}
                placeholder="Choose Type"
              />
            </div>
          )}
          {TypeID === "4" && (
            <div className="mt-4">
              <label htmlFor="Key" className="text-grey-6 f-16 d-block mb-1">
                Key<span className="text-danger"> *</span>
              </label>
              <input value={Information} onChange={(e) => setInformation(e.target.value)} type="text" placeholder="Enter url" className="w-100 input-style" id="Key" />
              {InformationError && <p className="f-12 text-danger">{InformationError}</p>}
            </div>
          )}
          <div className="mt-5 mb-5 text-right">
            {props.Type === "Add" && (
              <>
                {TypeID === "2" && (
                  <button disabled={!(Title && UserTypeID && Time && AndroidUrl && IOSUrl && Apr && Apy && Description && TypeID)} onClick={(e) => handleModal(e, "update")} className="form-button">
                    Save
                  </button>
                )}
                {TypeID !== "2" && (
                  <button onClick={(e) => handleModal(e, "add")} className="form-button" disabled={!(Title && UserTypeID && Time && Information && Apr && Apy && Description && TypeID)}>
                    Save
                  </button>
                )}
              </>
            )}
            {props.Type === "Edit" && (
              <div className="d-flex align-items-center justify-content-center">
                <button onClick={(e) => handleModal(e, "delete")} className="form-button form-button-ghost f-14 mr-2">
                  Delete
                </button>
                {TypeID === "2" ? (
                  <button disabled={!(Title && UserTypeID && AndroidUrl && IOSUrl && Time && Apr && Apy && Description && TypeID)} onClick={(e) => handleModal(e, "update")} className="form-button ml-2 f-14">
                    Update
                  </button>
                ) : (
                  <button disabled={!(Title && UserTypeID && Information && Time && Apr && Apy && Description && TypeID)} onClick={(e) => handleModal(e, "update")} className="form-button ml-2 f-14">
                    Update
                  </button>
                )}
              </div>
            )}
          </div>
        </form>
      </div>
      {OpenModal && <Modal Name={Title} Type={OpenModal} Close={(e, type) => CloseModal(e, type)} />}
      <RightSidebarStyle />
    </>
  );
}

const mapStateToProps = ({ ProductReducer }) => {
  const { loading, delete_data, add_data, edit_data } = ProductReducer;
  return { loading, delete_data, add_data, edit_data };
};

const mapDispatchToProps = {
  AddProduct,
  EditProduct,
  DeleteProduct,
};

export default connect(mapStateToProps, mapDispatchToProps)(RightSidebar);
